import { route, tag, type PageTour } from '../pageTour';

export const watchListTour: PageTour = {
  id: 'page-watch-list',
  version: 1,
  title: 'Watch List',
  summary: 'People and vehicles you want to be alerted about.',
  match: route('/watch-list'),
  steps: [
    {
      target: tag('watchlist-category'),
      title: 'Filter by category',
      description: 'Show only the people listed under one category, such as a particular kind of threat.',
      side: 'right',
    },
    {
      target: tag('watchlist-add'),
      title: 'Add a person',
      description: 'Pick someone already registered and add them to the watch list, so you are alerted when a camera sees them.',
      side: 'bottom',
      permission: 'ai_events.edit',
    },
    {
      target: tag('watchlist-results'),
      title: 'Who is being watched',
      description: 'Everyone this site is watching for. Use the People, Vehicles and Detections tabs above to switch to listed plates or recent sightings.',
      side: 'top',
    },
    {
      target: tag('watchlist-refresh'),
      title: 'Refresh',
      description: 'Reload the lists and the latest sightings.',
      side: 'bottom',
    },
  ],
};
